import {EmployeeType} from './employee-type.model';
import {Proof} from './Proof';

export class LivelihoodInformation {
    public id: string;
    public loanApplicationId: string;
    public industry: string;
    public company: string;
    public totalExperienceMonths: number;
    public employeeType: EmployeeType;
    public profession: string;
    public income: number;
    public version: number;
    public proofs: Proof[];

    constructor(loanApplicationId: string,
                industry?: string,
                company?: string,
                totalExperienceMonth?: number,
                employeeType?: EmployeeType,
                profession?: string,
                income?: number) {
        this.loanApplicationId = loanApplicationId;
        this.industry = industry;
        this.company = company;
        this.totalExperienceMonths = totalExperienceMonth;
        this.income = income;
        this.employeeType = employeeType;
        this.profession = profession;
    }
}
